import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psadetails',
  templateUrl: './psadetails.component.html',
  styleUrls: ['./psadetails.component.css']
})
export class PsadetailsComponent implements OnInit {
  menuList:any;
  pageList:any;
  constructor() { }

  ngOnInit() {

    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Functions')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psadetails.component.ts